import { render } from "./ExportFiles.vue?vue&type=template&id=2ae430b0"
import script from "./ExportFiles.vue?vue&type=script&lang=js"
export * from "./ExportFiles.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__